import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=bbe4a618&"
import script from "./FileDetail.vue?vue&type=script&lang=js&"
export * from "./FileDetail.vue?vue&type=script&lang=js&"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=bbe4a618&prod&lang=scss&"
import style1 from "./FileDetail.vue?vue&type=style&index=1&id=bbe4a618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports